module.exports = __webpack_public_path__ + "static/media/footseps.9a0ce0b6.png";